import { createSlice } from '@reduxjs/toolkit';
import { findLicenseTypesAPI, getLicenseTypeByIdAPI } from '../../../service/gplx/gplx.licseType.service';
// utils

const initialState = {
  isLoading: false,
  error: null,
  totalElements: 0,
  totalPages: 0,
  numberOfElements: 0,
  licenseTypes: [],
  licenseType: null,
  search: {
    page: 0,
    size: 10,
    value: '',
    orders: [
      {
        order: 'desc',
        property: 'orderNo',
      },
    ],
  },
};

const slice = createSlice({
  name: 'gplxLicenseType',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setLicenseTypes(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.licenseTypes = response.data;
      state.totalElements = response.totalElements;
      state.totalPages = response.totalPages;
      state.numberOfElements = response.numberOfElements;
    },
    setLicenseType(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.licenseType = response.data;
    },
    setLicenseTypeSearch(state, action) {
      state.isLoading = false;
      state.search = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;
// Actions
export const { setLicenseTypeSearch } = slice.actions;
// ----------------------------------------------------------------------

export function getLicenseTypes() {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    // read state from rootReducer
    const { licenseType } = getState();

    const resp = await findLicenseTypesAPI({ ...licenseType.search, value: `%${licenseType.search.value}%` });

    if (resp.code === '200') dispatch(slice.actions.setLicenseTypes(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}

export function getLicenseType(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const resp = await getLicenseTypeByIdAPI(id);
    if (resp.code === '200') dispatch(slice.actions.setLicenseType(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}
